export enum EventTypeExtended {
  CALL = 'call',
  VISIT = 'visit',
  MESSAGE = 'message',
  TBD = 'tbd',
  REMINDER = 'reminder',
}
